import { CheckCheckIcon } from "lucide-react";

type ProgramItemProps = {
  program: {
    serviceTitle: string;
    serviceText: string;
    serviceTicks: string[];
  };
  index: number;
};

export default function ProgramCard({ program, index }: ProgramItemProps) {
  const bgColor =
    index % 2 === 0 ? "bg-yellow-100/80" : "bg-secondary text-white";

  return (
    <div className={`flex flex-col items-start justify-start md:w-[450px] py-10 px-8 rounded-2xl gap-3 ${bgColor}`}>
      <h3 className="text-[22px] font-semibold">{program.serviceTitle}</h3>

      <p className="text-base">{program.serviceText}</p>

      <div className="flex flex-col w-full pt-2 gap-1">
        {program.serviceTicks.map((service, index) => (
          <h4 key={index} className="flex gap-3 text-base">
            <CheckCheckIcon />
            {service}
          </h4>
        ))}
      </div>
    </div>
  );
}
